import React from 'react';
import { Link } from 'react-router-dom';
import CreateSotSwitcher from './CreateSotSwitcher';
import JobsSotSwitcher from './JobsSotSwitcher';
import TrueEmptySwitcher from './TrueEmptySwitcher';
import { PWA_CREATE_SOT_NOTICE, PWA_TRUE_EMPTY_SOT_NOTICE } from './createPwaJob';
import { PWA_JOBS_PATH, PWA_JOBS_SOT_NOTICE } from './ordersSurface';

const DevJobsSotPage = () => (
    <div className="container w-full mx-auto pt-20" data-testid="jobs-sot-dev">
        <div className="flex flex-col items-center mt-10 px-6">
            <div className="status-empty-card w-10/12 mb-6">
                <p className="status-empty-eyebrow">JOBS · SOT</p>
                <h2>Prove empty / error / offline on Hosting</h2>
                <p>
                    Hosting production ignores <code>?jobsPreview=</code>. These links open{' '}
                    <code>/app/orders?jobsSot=</code> so AJ can prove <strong>JOBS · EMPTY</strong>,{' '}
                    <strong>JOBS · ERROR</strong>, <strong>JOBS · OFFLINE</strong>,{' '}
                    <strong>PENDING · EMPTY</strong>, <strong>PENDING · HANDOFF</strong>,{' '}
                    <strong>HANDOFF · ACTIVE</strong>, and{' '}
                    <strong>COMPLETE · HANDOFF</strong> without a zero-job tech or a live{' '}
                    <code>assignJob</code> / <code>completeJob</code> write. Assigned-jobs snapshot
                    does not run. Live assigned jobs are unchanged without the query.{' '}
                    <strong>Create job</strong> from <strong>JOBS · EMPTY</strong> is paint-only{' '}
                    <strong>CREATE · SOT</strong> — no confirm, Firestore add does not run. That is
                    not the true-empty live write. Live assignJob still writes active and the
                    assigned-jobs listener opens Active without a hard refresh. Live completeJob
                    still writes complete and the listener opens Complete without a hard refresh.
                    DEMO WALK current-step fill stays through that assign→complete handoff. Glass
                    only — never ADAS.
                </p>
                <JobsSotSwitcher />
                <p className="status-empty-note">{PWA_JOBS_SOT_NOTICE}</p>
                <Link className="status-empty-cta" to={PWA_JOBS_PATH}>
                    Open live assigned jobs
                </Link>
            </div>
            <div className="status-empty-card w-10/12 mb-6" data-testid="true-empty-dev">
                <p className="status-empty-eyebrow">TRUE EMPTY · WALK</p>
                <h2>Prove confirm → Firestore add without emptying a playground tech</h2>
                <p>
                    Hosting production ignores <code>?trueEmptyPreview=</code>. This link opens{' '}
                    <code>/app/orders?trueEmptySot=walk</code> so AJ can walk the true-empty{' '}
                    <strong>confirm → Firestore add</strong> path without a zero-job tech. Submit
                    shows the confirm dialog. Firestore add does not run. Live assigned jobs are
                    unchanged. On a real zero-job tech the same confirm writes pending assigned to
                    you. This is not <strong>CREATE · SOT</strong>. Glass only — never ADAS.
                </p>
                <TrueEmptySwitcher />
                <p className="status-empty-note">{PWA_TRUE_EMPTY_SOT_NOTICE}</p>
            </div>
            <div className="status-empty-card w-10/12 mb-6" data-testid="create-sot-dev">
                <p className="status-empty-eyebrow">CREATE · SOT</p>
                <h2>Prove create error / offline / denied on Hosting</h2>
                <p>
                    Hosting production ignores <code>?createPreview=</code>. These links open{' '}
                    <code>/app/orders?createSot=</code> so AJ can prove{' '}
                    <strong>CREATE · ERROR</strong>, <strong>CREATE · OFFLINE</strong>, and{' '}
                    <strong>CREATE · DENIED</strong> without emptying a playground tech or calling
                    Firestore add. The create modal opens on the helper card.{' '}
                    <strong>CREATE · SOT</strong> from <strong>JOBS · EMPTY</strong> stays paint-only
                    — no confirm — on submit. Glass only — never ADAS.
                </p>
                <CreateSotSwitcher />
                <p className="status-empty-note">{PWA_CREATE_SOT_NOTICE}</p>
            </div>
        </div>
    </div>
);

export default DevJobsSotPage;
